import UserContact from 'components/UserContact';
import { DepartmentRow } from 'components/tables/data/department/types';

/**
 * Column for contact person column.
 */
export default function ContactPersonColumn({ data: { contactPerson } }: { data: DepartmentRow }) {
  return contactPerson ? <UserContact {...contactPerson} email={contactPerson.email!} /> : '';
}
